module.exports = __webpack_public_path__ + "static/img/BusinessArea.39340a58.png";